<script setup>
const tips = [
  'Combine video content with live sessions for best results',
  'Start with 1-2 methods and expand as you grow',
  'Group sessions can be more profitable per hour'
]
</script>

<template>
  <section id="tips-section" class="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl p-6 text-white mb-6">
    <div class="flex items-start space-x-3 mb-4">
      <span class="material-symbols-outlined text-yellow-300 text-xl">lightbulb</span>
      <h4 class="text-lg font-bold">Pro Tips</h4>
    </div>
    <ul class="space-y-3 text-sm">
      <li v-for="(tip, index) in tips" :key="index" class="flex items-start space-x-2">
        <span class="material-symbols-outlined text-green-300 mt-0.5 text-base">check</span>
        <span>{{ tip }}</span>
      </li>
    </ul>
  </section>
</template>
